var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 21.8933L4.59829 35.3451C4.09499 35.8483 3.45444 36.1 2.67662 36.1C1.8988 36.1 1.25824 35.8483 0.754942 35.3451C0.251647 34.8418 0 34.2012 0 33.4234C0 32.6456 0.251647 32.005 0.754942 31.5017L14.2067 18.05L0.754942 4.59829C0.251647 4.09499 0 3.45444 0 2.67662C0 1.8988 0.251647 1.25824 0.754942 0.754942C1.25824 0.251647 1.8988 0 2.67662 0C3.45444 0 4.09499 0.251647 4.59829 0.754942L18.05 14.2067L31.5017 0.754942C32.005 0.251647 32.6456 0 33.4234 0C34.2012 0 34.8418 0.251647 35.3451 0.754942C35.8483 1.25824 36.1 1.8988 36.1 2.67662C36.1 3.45444 35.8483 4.09499 35.3451 4.59829L21.8933 18.05L35.3451 31.5017C35.8483 32.005 36.1 32.6456 36.1 33.4234C36.1 34.2012 35.8483 34.8418 35.3451 35.3451C34.8418 35.8483 34.2012 36.1 33.4234 36.1C32.6456 36.1 32.005 35.8483 31.5017 35.3451L18.05 21.8933Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.f6376852f075708c362a2fb05ab23a05.svg";
export { ForwardRef as ReactComponent };